﻿import FooterText from '../Texts/FooterText';

const FooterSection = (props) => {

    return (
        <section className="employer-branding__footer">
            <FooterText
                heading={props.heading}
                text1={props.text1}
                text2={props.text2}
                buttonText={props.buttonText}
                buttonLink={props.buttonLink} 
            />
        </section>
     )
 }                

export default FooterSection;